import { render, staticRenderFns } from "./LocationsItem.vue?vue&type=template&id=283d90de&scoped=true&"
import script from "./LocationsItem.vue?vue&type=script&lang=js&"
export * from "./LocationsItem.vue?vue&type=script&lang=js&"
import style0 from "./LocationsItem.vue?vue&type=style&index=0&id=283d90de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283d90de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
